import React from 'react';
import { connect } from 'react-redux';
import Table from '.';
import { mapDispachToProps, mapStateToProps } from "../../store/MapToProps";

import { customerStructure } from '../../data_formats';

const CustomerTable = (props) => {
  React.useEffect(() => {
    props.getAllCustomers()
  }, [])
  return (
    <>
      <Table
        title={"Customers"}
        pageTitle={"Customer"}
        columns={customerStructure}
        rows={props.customers.customers}
        rowsPerPage={50}
        pageSize={10}
        fieldKey={"customerStructure"}
        dataKey={"customers"}
        {...props}
      />
    </>
  )
}


export default connect(mapStateToProps, mapDispachToProps)(CustomerTable);